import { takeLatest, put, all, call } from "redux-saga/effects";

import ProfileTypes from "./profile.types";
import { encryptData } from "../_common/enode-decode";
import {
  updatePasswordFailure,
  updatePasswordSuccess,
  updateProfileImageDetailsFailure,
  updateProfileImageDetailsResponseChanged,
  updateProfileImageDetailsSuccess,
} from "./profile.action";
import { passwordUpdate, profileImageDetailsUpdate } from "./profile.service";
import { updateUserPasswordResponseChanged } from "../login/login.action";
/** *********************  START UPDATE PASSWORD LIST  ******************** */
export function* updatePassword({ payload }: any) {
  const {
    UserID,
    UserPassword,
    ProfileImageID,
    confirmPassword,
    UserName,
    UserPhoneNumber,
    currentPassword,
    newPassword,
    CompanyID,
    InstanceName,
    GeneralCompanyID,
    GeneralUserID,
  } = payload;
  try {
    const key = "UpdatePasswordKey";
    const jsonData = {
      UserID: UserID,
      userPassword: UserPassword,
      ProfileImageID: ProfileImageID,
      ConfirmPassword: confirmPassword,
      UserName: UserName,
      UserPhoneNo: UserPhoneNumber,
      CurrentPassword: currentPassword,
      NewPassword: newPassword,
      CompanyID: CompanyID,
      InstanceName: InstanceName,
      GeneralCompanyID: GeneralCompanyID,
      GeneralUserID: GeneralUserID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(passwordUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updatePasswordFailure(responseData.data));
    } else {
      yield put(updatePasswordSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updatePasswordFailure(error));
  }
}

export function* resetUpdatePasswordResponse() {
  yield put(updateUserPasswordResponseChanged());
}

export function* onUpdatePassword() {
  yield takeLatest(ProfileTypes.UPDATE_PASSWORD_START, updatePassword);
}

export function* onUpdatePasswordResponseReset() {
  yield takeLatest(
    ProfileTypes.UPDATE_PASSWORD_RESPONSE_RESET,
    resetUpdatePasswordResponse,
  );
}

/** *********************  END UPDATE PASSWORD  ******************** */

/** *********************  START UPDATE PROFILE IMAGE DETAILS  ******************** */
export function* profileImageUpdate({ payload }: any) {
  try {
    const key = "UpdateProfileKey";
    const {
      UserEmail,
      UserPhoneNo,
      CompanyPhoneNo,
      UserID,
      CompanyID,
      UserName,
      UserFullName,
      UserMotherMaidenName,
      UserPhoto,
      UserDOB,
      UserAddress1,
      UserAddress2,
      City,
      State,
      ZipCode,
      Country,
      UpdatedBy,
      CompanyWebsite,
      CompanyAddressLine1,
      CompanyAddressLine2,
      ProfileName,
      UpdatedUserName,
      OldProfileName,
      InstanceName,
      GeneralCompanyID,
      GeneralUserID,
    } = payload;
    const jsonData = {
      UserEmail: UserEmail,
      UserPhoneNo: UserPhoneNo,
      CompanyPhoneNo: CompanyPhoneNo,
      UserID: UserID,
      CompanyID: CompanyID,
      UserName: UserName,
      UserFullName: UserFullName,
      UserMotherMaidenName: UserMotherMaidenName,
      UserPhoto: UserPhoto,
      UserDOB: UserDOB,
      UserAddress1: UserAddress1,
      UserAddress2: UserAddress2,
      City: City,
      State: State,
      ZipCode: ZipCode,
      Country: Country,
      UpdatedBy: UpdatedBy,
      CompanyWebsite: CompanyWebsite,
      CompanyAddressLine1: CompanyAddressLine1,
      CompanyAddressLine2: CompanyAddressLine2,
      ProfileName: ProfileName,
      UpdatedUserName: UpdatedUserName,
      OldProfileName: OldProfileName,
      InstanceName: InstanceName,
      GeneralCompanyID: GeneralCompanyID,
      GeneralUserID: GeneralUserID,
    };
    const encodeData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(profileImageDetailsUpdate, encodeData);
    if (responseData.data.statusCode === "100") {
      yield put(updateProfileImageDetailsFailure(responseData.data));
    } else {
      yield put(updateProfileImageDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(updateProfileImageDetailsFailure(error));
  }
}

export function* resetUpdateProfileImageDetailsResponse() {
  yield put(updateProfileImageDetailsResponseChanged());
}

export function* onUpdateProfileImageDetails() {
  yield takeLatest(
    ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_START,
    profileImageUpdate,
  );
}

export function* onUpdateProfileImageResponseReset() {
  yield takeLatest(
    ProfileTypes.UPDATE_PROFILE_IMAGE_DETAILS_RESPONSE_RESET,
    resetUpdateProfileImageDetailsResponse,
  );
}
/** *********************  END UPDATE PROFILE IMAGE DETAILS ******************** */

export function* profileSaga() {
  yield all([
    call(onUpdatePassword),
    call(onUpdatePasswordResponseReset),
    call(onUpdateProfileImageDetails),
    call(onUpdateProfileImageResponseReset),
  ]);
}
